import { render, staticRenderFns } from "./CardLink.vue?vue&type=template&id=faa2579e&scoped=true"
import script from "./CardLink.vue?vue&type=script&lang=js"
export * from "./CardLink.vue?vue&type=script&lang=js"
import style0 from "./CardLink.vue?vue&type=style&index=0&id=faa2579e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faa2579e",
  null
  
)

export default component.exports